<template>
  <div class="relative w-full" ref="dropdownRef">
    <!-- Custom dropdown button -->
    <button
      type="button"
      @click="toggleDropdown"
      :disabled="disabled"
      :class="[
        'w-full rounded-xl shadow-cardShadow px-4 py-5 text-left flex justify-between items-center bg-white cursor-pointer',
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      ]"
    >
      <span :class="selectedValue ? 'label-text-normal font-semibold' : 'label-text-textSecondary'">
        {{ selectedValue || placeholder }}
      </span>
      <img :src="icon" alt="icon" :class="iconCss" />
    </button>

    <!-- Dropdown menu -->
    <ul
      v-if="open && !disabled"
      class="absolute mt-1 border border-gray-300 rounded-lg bg-white z-10 shadow-lg w-full overflow-y-scroll h-auto max-h-28"
    >
      <li
        v-for="option in options"
        :key="option"
        @click="selectOption(option)"
        class="px-4 py-2 hover:bg-blue-100 cursor-pointer label-text-normal font-semibold"
      >
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CustomDropdown",
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Select",
    },
    icon: {
      type: String,
      default: require('@/assets/date-icon.svg'),
    },
    modelValue: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconCss: {
      type: String,
      default: "w-5 h-5",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      open: false,
      selectedValue: this.modelValue,
    };
  },
  watch: {
    selectedValue(newVal) {
      this.$emit("update:modelValue", newVal);
    },
    modelValue(newVal) {
      this.selectedValue = newVal;
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return; // prevent opening when disabled
      this.open = !this.open;
    },
    selectOption(option) {
      if (this.disabled) return;
      this.selectedValue = option;
      this.open = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdownRef.contains(event.target)) {
        this.open = false;
      }
    },
    handleScroll(event) {
      if (!this.open || !this.$refs.dropdownRef) return;

      const dropdownEl = this.$refs.dropdownRef;

      // If the scroll/touch started inside the dropdown (or its children), do NOT close.
      // event.target may be a text node, so use closest fallback with contains check.
      const target = event.target && event.target.nodeType === 1 ? event.target : event.target.parentNode;
      if (dropdownEl.contains(target)) {
        return;
      }

      // Otherwise close
      this.open = false;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
      document.addEventListener("scroll", this.handleScroll, true);

  // use passive:true so we do not block scrolling (important for mobile/webviews)
  document.addEventListener("touchmove", this.handleScroll, { passive: true, capture: true });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  document.removeEventListener("scroll", this.handleScroll, true);
  document.removeEventListener("touchmove", this.handleScroll, { capture: true }); // remove matching listener
  },
};
</script>

<style scoped>
ul {
  transition: all 0.2s ease-in-out;
}
</style>
